import { styled } from "@mui/material/styles";

export const DivRowSpaceBetween = styled("div")`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const DivColSpaceBetween = styled("div")`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
`;

export const DivMarginCenterH = styled("div")`
  margin: 0 auto;
`;

export const DivFlexCenterHInside = styled("div")`
  display: flex;
  flex-direction: row;
  justify-content: center;
`;

export const DivFlexCenterVInside = styled("div")`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const DivFlexCenterInside = styled("div")`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

export const DivMarginBottom = styled("div")`
  margin-bottom: 0.35em;
`;
